// extracted by mini-css-extract-plugin
export default {"backBtn":"BackBtn_backBtn__T2JN3"};